export enum UserNotifyType {
  REFRESH_PAGE = 'refresh_page',
  REFRESH_PAGE_FORCEFULLY = 'refresh_page_forcefully',
  INVALIDATE_SESSION = 'invalidate_session'
}
